function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "1.9 5 20.2 14",
  fill: "currentColor"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 78"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.92 11.62a10.74 10.74 0 00-19.84 0 .94.94 0 000 .76 10.74 10.74 0 0019.84 0 .94.94 0 000-.76zM12 16a4 4 0 114-4 4 4 0 01-4 4z"
}))));